import { AjaxService, internalMessageBus, Cookies, EventsManager } from "../../externals";
import { PlatformRequestService, getTokenFromResponseV1, getTokenFromResponseV2 } from "../RequestService";
import { ApiVersion } from "../../types";
import { TokenHandler, CookiesStorage, TokenReader, TokenStream, TokenProcessingGateway, LogoutSubscription, PlatformLoginSubscription, OneTimeTokenSubscription } from "../../common";
import { RequestGateway, RenewErrorHandler } from "../../common";
import { delay, getClock, makeTokenRequest } from "../../helpers";
import { PlatformJwtManager } from "../../PlatformJwtManager";
export const platformAuthContextFactory = (config) => {
    if (!getTokenFromResponse[config.apiVersion]) {
        throw `Not supported api version: ${config.apiVersion}`;
    }
    const tokenReader = new TokenReader(config.siteID, getClock(config.timeControl, config.initialTime));
    const tokenStorage = new CookiesStorage(tokenReader, Cookies);
    const tokenHandler = new TokenHandler(tokenStorage, internalMessageBus);
    const service = new PlatformRequestService(config.apiUrl, config.siteID.toString(), new AjaxService(), getTokenFromResponse[config.apiVersion], makeTokenRequest);
    const errorHandler = new RenewErrorHandler(config.userInfo, new EventsManager());
    const tokenStream = new TokenStream(service, tokenHandler, tokenReader, errorHandler);
    const tokenProcessingGateway = new TokenProcessingGateway(tokenStream);
    const gateway = new RequestGateway(service, tokenProcessingGateway, tokenStorage, tokenReader, delay);
    const platformJwtManager = new PlatformJwtManager(tokenStorage, config.userInfo, tokenReader, gateway);
    return {
        Gateway: gateway,
        PlatformJwtManager: platformJwtManager,
        Subscriptions: getSubscriptions(gateway, config, service, tokenReader)
    };
};
const getTokenFromResponse = {
    [ApiVersion.v1]: getTokenFromResponseV1,
    [ApiVersion.v2]: getTokenFromResponseV2
};
const getSubscriptions = (gateway, config, service, tokenReader) => [
    new LogoutSubscription(config.userInfo, gateway, tokenReader),
    new PlatformLoginSubscription(config.userInfo, gateway),
    new OneTimeTokenSubscription(config.userInfo, gateway, service)
];
//# sourceMappingURL=PlatformAuthContextFactory.js.map